import helpers from '../helpers';

function scroll() {
	if (helpers.isMobile() && $('.hero').offset().top + $('.hero').innerHeight() <= pageYOffset + innerHeight) {
		$('.hero-footer__social').css({
			position: 'absolute',
			bottom: '-1px',
		});
	} else if (helpers.isMobile() && $('.hero').offset().top + $('.hero').innerHeight() >= pageYOffset + innerHeight) {
		$('.hero-footer__social').css({
			position: '',
			bottom: 0,
		});
	}
}

function init() {
	scroll();

	helpers.$window.on('scroll.hero', scroll);
}

export default {
	init,
};
